var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid",attrs:{"id":"network-container"}},[_c('div',{attrs:{"id":"networkChart"}}),_c('div',{attrs:{"id":"network-tooltip"}}),_c('p',{attrs:{"id":"center"}},[_vm._v(_vm._s(_vm.selectedJournalist["Nombre"]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }